import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-integrated-course-data',
  templateUrl: './integrated-course-data.component.html',
  styleUrls: ['./integrated-course-data.component.scss']
})
export class IntegratedCourseDataComponent implements OnInit {
  inteCourseForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  list;
  inteCourseSearchForm;
  inteCourseList: any;
  coCodeList: any;
  filteredListCoCode: any;
  examStreamCourseList: any;
  filteredListExamStreamCode: any;
  constructor( public umsService: UmsService,
    private fb: FormBuilder,   public router: Router,
    private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.submitButton = true;
    this.editButton = false;
   
    this.list = true;
    this.inteCourseForm = this.fb.group({
      Inst: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcCoCode: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcSrNo: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcEmId: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcCertName: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcCertTo: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoCode: new FormControl ('')
    });
    this.inteCourseSearchForm = this.fb.group({
      IcCoCode: new FormControl (''),
      FilterType: new FormControl ('LIKE'),
    });
    this.getInteCourseData();
    this.fetchCourseCode();
    this.fetchExamCode();
  }


  keypress(){
    this.umsService.searchFaculty(this.inteCourseSearchForm.value).subscribe(res => {
      this.inteCourseList = res.data;
      },(ERROR: HttpErrorResponse) => {
        this.inteCourseList = [];
     });
  }

  getInteCourseData() {
    const payload = {};
    // payload['IcCoCode']=id;
    this.umsService.getIntegratedCourse(payload).subscribe(res => {
      this.inteCourseList = res.data;
      // this.dataSource = new MatTableDataSource(this.facultyList);
      });
  }

  download(){
    let wwe =['EmSrNo','EmId','EmCode','IcCertName','IcCertTo']
    this.umsService.downloadFile(this.inteCourseList, 'jsontocsv', wwe);
  }
  
  prepopulation(id) {
    const payload = {};
    // tslint:disable-next-line:no-string-literal
    payload['IcCoCode'] = id;
    this.umsService.getIntegratedCourse(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status){
         this.editButton = true;
         this.submitButton = false;
         this.inteCourseForm = this.fb.group({
      Inst: new FormControl (data.Inst, [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcCoCode: new FormControl (data.IcCoCode, [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcSrNo: new FormControl (data.IcSrNo, [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcEmId: new FormControl (data.IcEmId, [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcCertName: new FormControl (data.IcCertName, [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      IcCertTo: new FormControl (data.IcCertTo, [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoCode: new FormControl ('')
    });
       }else{
         this.umsService.openSnackbar(res.message);
       }
     });
  }


  submit(){
    if (this.inteCourseForm.invalid) {
      this.inteCourseForm.get('Inst').markAsTouched();
      this.inteCourseForm.get('IcCoCode').markAsTouched();
      this.inteCourseForm.get('IcSrNo').markAsTouched();
      this.inteCourseForm.get('IcEmId').markAsTouched();
      this.inteCourseForm.get('IcCertName').markAsTouched();
      this.inteCourseForm.get('IcCertTo').markAsTouched();
      return;
    } else {
      
      this.inteCourse();
    }
  }

  inteCourse() {
    this.submitpayload = this.inteCourseForm.value;
    this.umsService.addInteCourse(this.submitpayload).subscribe(res => {
      if (res.status){
        
        this.umsService.openSnackbar(res.message);
        this.ngOnInit();
      } else {
        this.umsService.openSnackbar(res.message);
      }
    });
  }

  update(){
    if (this.inteCourseForm.invalid) {
      this.inteCourseForm.get('Inst').markAsTouched();
      this.inteCourseForm.get('IcCoCode').markAsTouched();
      this.inteCourseForm.get('IcSrNo').markAsTouched();
      this.inteCourseForm.get('IcEmId').markAsTouched();
      this.inteCourseForm.get('IcCertName').markAsTouched();
      this.inteCourseForm.get('IcCertTo').markAsTouched();
     return;
    } else {
      this.updateInteCourse();
    }
  }

  updateInteCourse() {
    this.submitpayload = this.inteCourseForm.value;
  }

  addnewrecord(e){
    if (e === 'true'){
      this.ngOnInit();
      this.list = false;
      this.editButton = false;
      this.submitButton = true;
      this.inteCourseForm = this.fb.group({
        Inst: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
        IcCoCode: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
        IcSrNo: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
        IcEmId: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
        IcCertName: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
        IcCertTo: new FormControl ('', [Validators.required,Validators.pattern("^[a-zA-Z0-9]*$")]),
        CoCode: new FormControl ('')
     });
    } else {
      this.list = true;
    }
  }

  editdata(e, k){
    if (e === 'true'){
      this.list = false;
      this.getInteCourseData();
      this.inteCourseForm = k;
      this.prepopulation(this.inteCourseForm);
    } else {
      this.list = true;
    }
  }

  delete(e){
    alert('delete' + e);
  }

  fetchCourseCode() {
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {    
        this.coCodeList = res.data;
        this.filteredListCoCode= this.coCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  } 

  integretedCourseSort(e){
    const payload = {};
    payload['IcCoCode'] = e.CoCode;
      this.umsService.getIntegratedCourse(payload).subscribe(res => {
        this.inteCourseList = res.data;
      });
   }

   fetchExamCode() {
    const payload = {};
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {    
        this.examStreamCourseList = res.data;
        this.filteredListExamStreamCode= this.examStreamCourseList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  } 
}
